import { render, staticRenderFns } from "./ReportUserResponsibilities.vue?vue&type=template&id=72927ed0&"
import script from "./ReportUserResponsibilities.vue?vue&type=script&lang=js&"
export * from "./ReportUserResponsibilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports